// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"35bf5803","295":"67ff7025","612":"29e665f4","787":"a0aa6d74","830":"9c331d97","906":"1e45654c","921":"f3a56a23","928":"9d74f1a5"}[chunkId] + ".chunk.js";
};